import store from '@/store'
import helper from './helper'

const { getFormattedDateNoTime } = helper()

const bodyForBooking = orderItems => {
  // Create email-compatible three-line layout with proper table alignment
  let bodyHTML = `
    <table width="100%" cellpadding="0" cellspacing="0" style="max-width: 700px; margin: 0 auto; font-family: Arial, sans-serif;">
      <tr>
        <td style="background: white; padding: 30px;">
          <h2 style="color: #2c3e50; margin-bottom: 20px; border-bottom: 2px solid #e0e0e0; padding-bottom: 10px;">
            Ihre gebuchten Lagerplätze
          </h2>
  `

  // Generate each booking item with three-line layout
  orderItems.forEach(orderItem => {
    const location = store.getters.locationById(
      Number(orderItem.storage.location)
    )

    bodyHTML += `
          <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom: 25px; border-left: 4px solid #007bff; background-color: #f9f9f9;">
            <tr>
              <td style="padding: 15px;">
                <!-- Line 1: Location -->
                <div style="font-weight: bold; color: #2c3e50; font-size: 14px; margin-bottom: 12px;">
                  📍 Standort: ${location.city}, ${location.street} ${location.streetNumber}; Tornummer: ${location.gatePhone}
                </div>

                <!-- Storage Info Table (Headers + Values) -->
                <table width="100%" cellpadding="5" cellspacing="0" style="font-size: 13px; border-collapse: collapse;">
                  <!-- Headers Row -->
                  <tr style="background-color: #e9ecef;">
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 15%;">Lager</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">ID</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; background-color: #fff3cd; border-right: 1px solid #dee2e6; width: 12%;">PIN</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 18%;">Mietbeginn</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 18%;">Mietende</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; width: 17%;">Preis/Monat</td>
                  </tr>
                  <!-- Values Row -->
                  <tr style="background-color: white;">
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 15%;">${orderItem.storage.name}</td>
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">${orderItem.storage.storageIdent}</td>
                    <td style="padding: 8px; color: #333; font-weight: bold; text-align: center; background-color: #fff3cd; border-right: 1px solid #dee2e6; width: 12%;">${orderItem.storage.lockPin}</td>
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 18%;">${getFormattedDateNoTime(orderItem.rentStart)}</td>
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 18%;">${!orderItem.rentEnd || orderItem.rentEnd === '2099-12-31T23:00:00.000Z' ? 'offen' : getFormattedDateNoTime(orderItem.rentEnd)}</td>
                    <td style="padding: 8px; color: #28a745; font-weight: bold; text-align: center; width: 17%;">${orderItem.price}€</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
    `
  })

  // Close the main container
  bodyHTML += `
        </td>
      </tr>
    </table>
  `

  return bodyHTML
}

const bodyForInquiry = storageItems => {
  // Safety check for undefined or empty storage items
  if (!storageItems || !Array.isArray(storageItems) || storageItems.length === 0) {
    console.warn('bodyForInquiry: Invalid or empty storageItems', storageItems)
    return '<p>Keine Lagerplätze verfügbar.</p>'
  }

  // Create email-compatible three-line layout with proper table alignment
  let bodyHTML = `
    <table width="100%" cellpadding="0" cellspacing="0" style="max-width: 700px; margin: 0 auto; font-family: Arial, sans-serif;">
      <tr>
        <td style="background: white; padding: 30px;">
          <h2 style="color: #2c3e50; margin-bottom: 20px; border-bottom: 2px solid #e0e0e0; padding-bottom: 10px;">
            Ihre angefragten Lagerplätze
          </h2>
  `

  // Generate each storage item with three-line layout
  storageItems.forEach(storage => {
    const location = store.getters.locationById(Number(storage.location))

    bodyHTML += `
          <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom: 25px; border-left: 4px solid #007bff; background-color: #f9f9f9;">
            <tr>
              <td style="padding: 15px;">
                <!-- Line 1: Location -->
                <div style="font-weight: bold; color: #2c3e50; font-size: 14px; margin-bottom: 12px;">
                  📍 Standort: ${location.city}, ${location.street} ${location.streetNumber}
                </div>

                <!-- Storage Info Table (Headers + Values) -->
                <table width="100%" cellpadding="5" cellspacing="0" style="font-size: 13px; border-collapse: collapse;">
                  <!-- Headers Row -->
                  <tr style="background-color: #e9ecef;">
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">Name</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 25%;">ID</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">Mietbeginn</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">Mietende</td>
                    <td style="padding: 6px; color: #666; font-weight: bold; text-align: center; width: 15%;">Preis/Monat</td>
                  </tr>
                  <!-- Values Row -->
                  <tr style="background-color: white;">
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">${storage.name}</td>
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 25%;">${storage.storageIdent}</td>
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">${getFormattedDateNoTime(storage.rentStart)}</td>
                    <td style="padding: 8px; color: #333; text-align: center; border-right: 1px solid #dee2e6; width: 20%;">${!storage.rentEnd || storage.rentEnd === '2099-12-31T23:00:00.000Z' ? 'offen' : getFormattedDateNoTime(storage.rentEnd)}</td>
                    <td style="padding: 8px; color: #28a745; font-weight: bold; text-align: center; width: 15%;">${storage.price}€</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
    `
  })

  // Close the main container
  bodyHTML += `
        </td>
      </tr>
    </table>
  `

  return bodyHTML
}

export default function emailStoragesBody(emailItems, emailType) {
  console.log('🚀 ~ file: emailStoragesBody.js:95 ~ emailItems:', emailItems)
  console.log('🚀 ~ file: emailStoragesBody.js:96 ~ emailType:', emailType)
  if (emailType === 'booking') {
    return bodyForBooking(emailItems)
  }
  if (emailType === 'offer') {
    return bodyForInquiry(emailItems)
  }
  return '<p>Fehler bei der Erstellung des E-Mail-Textes. Bitte kontaktieren Sie uns.</p>'
}
